import { useMemo } from 'react';
import { LocalizedText, useSafeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CurrentSection as CurrentAccountSection } from '../CurrentSection';
import { SelectedAccountIdsContext } from '../context';
import { AnotherAccountSection } from '../AnotherAccountSection';
import { Section } from './enum';
import { ItemAssignmentDialogContentOwnProps } from './types';
import { ItemAssignmentDialogContentSwitch } from './ItemAssignmentDialogContentSwitch';

export const ItemAssignmentDialogContentCompany = ({
    scope,
    billId,
    accountIds,
}: ItemAssignmentDialogContentOwnProps) => {
    const { selectedAccountId } = useSafeContext(SelectedAccountIdsContext);

    const dataTestIds = {
        [Section.Current]: 'data-current-company-section',
        [Section.Search]: 'data-another-company-section',
        [Section.Another]: 'data-another-customer-section',
    };

    const labels = {
        [Section.Current]: <LocalizedText textKey={TextKey.CurrentCompany} />,
        [Section.Search]: <LocalizedText textKey={TextKey.AnotherCompany} />,
        [Section.Another]: <LocalizedText textKey={TextKey.Customer} />,
    };

    const sections = useMemo(
        () => ({
            [Section.Current]: <CurrentAccountSection billId={billId} accountIds={accountIds} scope={scope} />,
            [Section.Search]: (
                <AnotherAccountSection
                    billId={billId}
                    defaultAccountIds={accountIds}
                    scope={scope}
                    accountId={selectedAccountId}
                    isCompany
                />
            ),
            [Section.Another]: (
                <AnotherAccountSection billId={billId} scope={scope} accountId={selectedAccountId} isCompany={false} />
            ),
        }),
        [accountIds, billId, scope, selectedAccountId]
    );

    return (
        <ItemAssignmentDialogContentSwitch
            scope={scope}
            dataTestIds={dataTestIds}
            sections={sections}
            labels={labels}
        />
    );
};
